import { SampleConsensusModel } from "./sac_model";
import * as THREE from "../../libs/three.js/build/three.module.js";
export class Matrix3x3 {
    constructor(values) {
      this.values = values || [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ];
          // 使用 Proxy 来拦截数组的操作，实现类似 mat[0][0] 的访问
          return new Proxy(this, {
            get: (target, prop) => {
              if (typeof prop === 'string' && prop.match(/^\d+$/)) {
                const row = parseInt(prop);
                return new Proxy(target.values[row], {
                  get: (target, col) => {
                    if (typeof col === 'string' && col.match(/^\d+$/)) {
                      return target[parseInt(col)];
                    }
                  }
                });
              }
              return target[prop];
            }
          });
    }
    convertTHREEToMatrix3x3(threeMatrix) {
        const elements = threeMatrix.elements; // 获取THREE.Matrix3的元素数据
        
        // 将元素转换为3x3二维数组
        const values = [
          [elements[0], elements[3], elements[6]],
          [elements[1], elements[4], elements[7]],
          [elements[2], elements[5], elements[8]]
        ];
        
        // 创建一个新的Matrix3x3对象，并将转换后的值赋给它
        return new Matrix3x3(values);
      }
    // 矩阵乘法
    multiply(other) {
      const result = [
        [0, 0, 0],
        [0, 0, 0],
        [0, 0, 0]
      ];
  
      for (let i = 0; i < 3; i++) {
        for (let j = 0; j < 3; j++) {
          for (let k = 0; k < 3; k++) {
            result[i][j] += this.values[i][k] * other.values[k][j];
          }
        }
      }
  
      return new Matrix3x3(result);
    }
  
    // 矩阵转置
    transpose() {
      const result = [
        [this.values[0][0], this.values[1][0], this.values[2][0]],
        [this.values[0][1], this.values[1][1], this.values[2][1]],
        [this.values[0][2], this.values[1][2], this.values[2][2]]
      ];
  
      return new Matrix3x3(result);
    }
  
    // 输出矩阵
    // print() {
    //   console.table(this.values);
    // }
  }
export class SampleConsensusModelPlane extends SampleConsensusModel{
    constructor(input, sample_size) {
        super(input); 
        this.input = input; // input is expected to be an array of points (like [{x, y, z}, ...])
        this.sampleSize_ = 3;
        this.modelSize_ = 4;
    }

    isSampleGood(samples) {
        if (samples.length !== this.sampleSize_) {
            console.error(`[SampleConsensusModelPlane::isSampleGood] Wrong number of samples (is ${samples.length}, should be ${this.sampleSize_})!`);
            return false;
        }

        const p0 = this.input[samples[0]];
        const p1 = this.input[samples[1]];
        const p2 = this.input[samples[2]];

        const cross = this.crossProduct(p1, p0, p2);
        const crossNorm = this.vectorNorm(cross);

        if (crossNorm < Number.EPSILON) {
            console.error("[SampleConsensusModelPlane::isSampleGood] Sample points too similar or collinear!");
            return false;
        }

        return true;
    }

    computeModelCoefficients(samples) {
        if (samples.length !== this.sampleSize_) {
            console.error(`[SampleConsensusModelPlane::computeModelCoefficients] Invalid set of samples given (${samples.length})!`);
            return [];
        }

        const p0 = this.input[samples[0]];
        const p1 = this.input[samples[1]];
        const p2 = this.input[samples[2]];
        // const p0 = new THREE.Vector3(-4.630000,-4.340000,2.340000);
        // const p1 = new THREE.Vector3(-4.680000,-4.210000,1.760000);
        // const p2 = new THREE.Vector3(-4.630000,-3.600000,1.800000);
        const cross = this.crossProduct(p1, p0, p2);
        const crossNorm = this.vectorNorm(cross);
        // console.log(`SampleConsensusModelPlane::computeModelCoefficients] cross is: ${cross.x}x + ${cross.y}y + ${cross.z}z `);
        // console.log(`SampleConsensusModelPlane::computeModelCoefficients] crossNorm is ${crossNorm}`);
  
        if (crossNorm < Number.EPSILON) {
            console.error("[SampleConsensusModelPlane::computeModelCoefficients] Chosen samples are collinear!");
            return [];
        }
        // const dot = this.dotProduct(cross, p0);
        // const modelCoefficients = [cross[0] / crossNorm, cross[1] / crossNorm, cross[2] / crossNorm, -this.dotProduct(cross, p0)];
        // const modelCoefficients = [cross.x / crossNorm, cross.y / crossNorm, cross.z / crossNorm, -this.dotProduct(cross/ crossNorm, p0)];
        // this.modelCoefficients = modelCoefficients;
        // this.modelCoefficients = new THREE.Vector4(cross.x / crossNorm, cross.y / crossNorm, cross.z / crossNorm, -this.dotProduct(cross, p0));
        let modelCoefficients = [];
        modelCoefficients.push(cross.x / crossNorm);
        modelCoefficients.push(cross.y / crossNorm);
        modelCoefficients.push(cross.z / crossNorm);
        // const dot = this.dotProduct(modelCoefficients, p0);
        let modelCoefficientsVec3 = new THREE.Vector3(modelCoefficients[0], modelCoefficients[1], modelCoefficients[2]);
        modelCoefficients.push(-this.dotProduct(modelCoefficientsVec3, p0));

        // this.modelCoefficients.push(-this.dotProduct(cross, p0));
        return modelCoefficients;
        // return true;
    }

    getDistancesToModel(modelCoefficients) {
        if (!this.isModelValid(modelCoefficients)) {
            console.error("[SampleConsensusModelPlane::getDistancesToModel] Given model is invalid!");
            return [];
        }

        const distances = [];
        for (let i = 0; i < this.input.length; i++) {
            const pt = this.input[i];
            const distance = Math.abs(this.dotProduct(modelCoefficients, pt));
            distances.push(distance);
        }

        return distances;
    }

    selectWithinDistance(modelCoefficients, threshold,inliers) {
        if (!this.isModelValid(modelCoefficients)) {
            console.error("[SampleConsensusModelPlane::selectWithinDistance] Given model is invalid!");
            return [];
        }
        inliers.length = 0;
        this.error_sqr_dists_.length = 0;
        // const inliers = [];
        for (let i = 0; i < this.input.length; i++) {
            // const pt = this.input[i];
            const pt = new THREE.Vector4(this.input[i].x,this.input[i].y,this.input[i].z,1.000000)
            const modelCoefficientsVec4 = new THREE.Vector4(modelCoefficients[0], modelCoefficients[1], modelCoefficients[2], modelCoefficients[3]);
            const distance = Math.abs(this.dotProductVec4(modelCoefficientsVec4, pt));
            // const ptVec = new THREE.Vector4(8.902384,1.505393,23.450493,1.000000)
            // const modelCoefficientsVec42 = new THREE.Vector4(0.540483,0.796391,-0.271367,0.393295);
            // const distanceTest = Math.abs(this.dotProductVec4(modelCoefficientsVec42, ptVec));
            // console.log(`Fitted Plane Equation:pt: ${pt.x}x + ${pt.y}y + ${pt.z}z + ${pt.w}w`);
            // console.log(`Fitted Plane Equation:modelCoefficients ${modelCoefficients[0]}x + ${modelCoefficients[1]}y + ${modelCoefficients[2]}z + ${modelCoefficients[3]} = 0`);
            if (distance < threshold) {
                inliers.push(i);
                this.error_sqr_dists_.push (distance);
            }
        }

        return inliers;
    }
    countWithinDistanceStandard(modelCoefficients, threshold, i) {
        let nrP = 0;
        // Iterate through the 3d points and calculate the distances from them to the plane
        for (let j = i; j < this.indices_.length; ++j) {
            // Get the point coordinates (assuming input is an array of points, where each point is an object with x, y, z)
            const pt = [
                this.input[this.indices_[j]].x,
                this.input[this.indices_[j]].y,
                this.input[this.indices_[j]].z,
                1.0 // Homogeneous coordinate
            ];
    
            // Calculate the dot product of modelCoefficients and pt
            const dotProduct = modelCoefficients.reduce((sum, coeff, index) => sum + coeff * pt[index], 0);
            
            // Check if the absolute value of the dot product is less than the threshold
            if (Math.abs(dotProduct) < threshold) {
                nrP++;
            }
        }
        return nrP;
    }
    countWithinDistanceAVX(modelCoefficients, threshold, i=0) {
        let nrP = 0;
        
        // Equivalent of AVX vectors
        let aVec = new Array(8).fill(modelCoefficients[0]);
        let bVec = new Array(8).fill(modelCoefficients[1]);
        let cVec = new Array(8).fill(modelCoefficients[2]);
        let dVec = new Array(8).fill(modelCoefficients[3]);
        let thresholdVec = new Array(8).fill(threshold);
        let absHelp = new Array(8).fill(-0.0); // Represents negative zero
        
        let res = new Array(8).fill(0); // To store inlier count
    
        // Main loop (process 8 points at a time)
        for (; i + 8 <= this.indices_.length; i += 8) {
            // Calculate distances and check if they're within the threshold
            let mask = this.dist8(i, aVec, bVec, cVec, dVec, absHelp, thresholdVec);
            
            // Sum the inliers based on the mask
            for (let j = 0; j < 8; j++) {
                if (mask[j]) {
                    res[j] = 1;
                }
            }
    
            // Sum up the results (inliers) from the 8 results in the vector
            nrP += res.reduce((acc, val) => acc + val, 0);
        }
    
        // Process remaining points (less than 8)
        nrP += this.countWithinDistanceStandard(modelCoefficients, threshold, i);
        
        return nrP;
    }
    PCLAT(POS) {
        return this.input_[this.indices_[POS]]; // Access the point at the index given by indices_[POS]
    }
    // dist8(i, aVec, bVec, cVec, dVec, absHelp) {
    //     // Initialize an array to hold the results of the distance calculations
    //     let result = new Array(8);
    
    //     for (let j = 0; j < 8; j++) {
    //         // Access the points PCLAT(i) based on the indices
    //         const x = this.PCLAT(i + j).x;
    //         const y = this.PCLAT(i + j).y;
    //         const z = this.PCLAT(i + j).z;
    
    //         // Calculate the distance using the model coefficients
    //         let dist = (aVec[j] * x) + (bVec[j] * y) + (cVec[j] * z) + dVec[j];
    
    //         // Apply the absolute value operation (using Math.abs in JavaScript)
    //         dist = Math.abs(dist);  // In JavaScript, we use Math.abs to remove the sign bit
    
    //         // Store the result
    //         result[j] = dist;
    //     }
    
    //     // Return the result array
    //     return result;
    // }
  // PCLAT(i) is assumed to be a function that returns an object with .x, .y, .z properties.
    dist8(i, a_vec, b_vec, c_vec, d_vec, abs_help) {
    // Create an array of points based on PCLAT(i)
    let points = [
        { x: this.PCLAT(i).x, y: this.PCLAT(i).y, z: this.PCLAT(i).z },
        { x: this.PCLAT(i+1).x, y: this.PCLAT(i+1).y, z: this.PCLAT(i+1).z },
        { x: this.PCLAT(i+2).x, y: this.PCLAT(i+2).y, z: this.PCLAT(i+2).z },
        { x: this.PCLAT(i+3).x, y: this.PCLAT(i+3).y, z: this.PCLAT(i+3).z },
        { x: this.PCLAT(i+4).x, y: this.PCLAT(i+4).y, z: this.PCLAT(i+4).z },
        { x: this.PCLAT(i+5).x, y: this.PCLAT(i+5).y, z: this.PCLAT(i+5).z },
        { x: this.PCLAT(i+6).x, y: this.PCLAT(i+6).y, z: this.PCLAT(i+6).z },
        { x: this.PCLAT(i+7).x, y: this.PCLAT(i+7).y, z: this.PCLAT(i+7).z }
    ];

    // Initialize result array for distances
    let result = [];

    // Perform calculations similar to the original code
    for (let j = 0; j < 8; j++) {
        // Each point (PCLAT(i + j)) has x, y, z components, and we need to calculate the distance to the plane
        let distance = a_vec[j] * points[j].x + b_vec[j] * points[j].y + c_vec[j] * points[j].z + d_vec[j];

        // Apply the absolute help logic (this is a simple placeholder for sign removal)
        let abs_distance = Math.abs(distance); // Equivalent to removing the sign bit in SIMD version
        if (abs_help) {
            result.push(abs_distance); // If abs_help is set, push the absolute value
        } else {
            result.push(distance); // Otherwise, keep the signed value
        }
    }

    return result;
}
getPoint(index) {
    return this.input_[index];
  }
//   getPoint(index) {
//     return this.input_[this.indices_[index]]; // Access the point at the index given by indices_[POS]
// }
  // 模拟一个函数来计算点到平面的距离
 countWithinDistanceStandard( modelCoefficients, threshold, i = 0) {
    let nr_p = 0;
    
    // 遍历点索引
    for (let idx = i; idx < this.indices_.length; ++idx) {
      // 获取当前点的坐标
      let point = this.getPoint(this.indices_[idx]);
      
      // 计算点到平面的距离：D = (P-A).N / |N|
      // modelCoefficients 是 [A, B, C, D]，表示平面方程 Ax + By + Cz + D = 0
      let pt = [point.x, point.y, point.z, 1.0]; // 点坐标 (x, y, z, 1)
  
      // 计算点到平面的距离，使用点积
      let dotProduct = modelCoefficients[0] * pt[0] + modelCoefficients[1] * pt[1] +
                       modelCoefficients[2] * pt[2] + modelCoefficients[3] * pt[3];
  
      // 如果距离小于阈值，则认为该点在平面附近
      if (Math.abs(dotProduct) < threshold) {
        nr_p++;
      }
    }
    if (nr_p === 10742) {
        console.log(`------------------countWithinDistanceStandard :nr_p: ${nr_p}x `);
    }
    return nr_p;
  }
    
    // Helper function to simulate distance computation (this is an approximation, you should implement this based on your actual logic)
    // dist8(i, aVec, bVec, cVec, dVec, absHelp, thresholdVec) {
    //     let mask = new Array(8).fill(false);
    
    //     for (let j = 0; j < 8; j++) {
    //         // Simulate the distance computation and compare with threshold
    //         let dist = Math.abs(aVec[j] * input[indices[i + j]].x + 
    //                             bVec[j] * input[indices[i + j]].y + 
    //                             cVec[j] * input[indices[i + j]].z + 
    //                             dVec[j]);
            
    //         if (dist < thresholdVec[j]) {
    //             mask[j] = true;
    //         }
    //     }
    
    //     return mask;
    // }
    countWithinDistance(modelCoefficients, threshold) {
        // Check if the model coefficients are valid
        if (!this.isModelValid(modelCoefficients)) {
            console.error("[SampleConsensusModelPlane::countWithinDistance] Given model is invalid!");
            return 0;
        }
    
        return this.countWithinDistanceStandard(modelCoefficients, threshold);
    }
    
    
    // countWithinDistance(modelCoefficients, threshold) {
    //     if (!this.isModelValid(modelCoefficients)) {
    //         console.error("[SampleConsensusModelPlane::countWithinDistance] Given model is invalid!");
    //         return 0;
    //     }

    //     let count = 0;
    //     for (let i = 0; i < this.input.length; i++) {
    //         const pt = this.input[i];
    //         const ptVec4 = new THREE.Vector4(pt.x, pt.y, pt.z, 1);
    //         const modelCoefficientsVec = new THREE.Vector4(modelCoefficients[0], modelCoefficients[1], modelCoefficients[2], modelCoefficients[3]);
    //         const distance = Math.abs(this.dotProduct(modelCoefficientsVec, ptVec4));

    //         if (distance < threshold) {
    //             count++;
    //         }
    //     }

    //     return count;
    // }

    // optimizeModelCoefficients(inliers, modelCoefficients) {
    //     if (!this.isModelValid(modelCoefficients)) {
    //         console.error("[SampleConsensusModelPlane::optimizeModelCoefficients] Given model is invalid!");
    //         return modelCoefficients;
    //     }

    //     if (inliers.length <= this.sampleSize_) {
    //         console.error(`[SampleConsensusModelPlane::optimizeModelCoefficients] Not enough inliers found to optimize model coefficients (${inliers.length})!`);
    //         return modelCoefficients;
    //     }

    //     // Here you can implement Least-Squares fitting, for now, just return model coefficients.
    //     return modelCoefficients;
    // }
    computeRoots2(b, c, roots) {
        roots[0] = 0;
        let d = b * b - 4.0 * c;
        if (d < 0.0)  // no real roots! This should not happen!
            d = 0.0;
    
        let sd = Math.sqrt(d);
    
        roots[2] = 0.5 * (b + sd);
        roots[1] = 0.5 * (b - sd);
    }
    
    computeRoots(m) {
        let roots = [];
        // The characteristic equation is x^3 - c2*x^2 + c1*x - c0 = 0.
        // The eigenvalues are the roots to this equation, all guaranteed to be real-valued, 
        // because the matrix is symmetric.
        
        let c0 = m[0][0] * m[1][1] * m[2][2]
            + 2.0 * m[0][1] * m[0][2] * m[1][2]
            - m[0][0] * m[1][2] * m[1][2]
            - m[1][1] * m[0][2] * m[0][2]
            - m[2][2] * m[0][1] * m[0][1];
        
        let c1 = m[0][0] * m[1][1]
            - m[0][1] * m[0][1]
            + m[0][0] * m[2][2]
            - m[0][2] * m[0][2]
            + m[1][1] * m[2][2]
            - m[1][2] * m[1][2];
        
        let c2 = m[0][0] + m[1][1] + m[2][2];
    
        if (Math.abs(c0) < Number.EPSILON) {  // One root is 0, use quadratic equation
            computeRoots2(c2, c1, roots);
        } else {
            const s_inv3 = 1.0 / 3.0;
            const s_sqrt3 = Math.sqrt(3.0);
    
            // Construct the parameters used in classifying the roots of the equation
            // and in solving the equation for the roots in closed form.
            let c2_over_3 = c2 * s_inv3;
            let a_over_3 = (c1 - c2 * c2_over_3) * s_inv3;
            if (a_over_3 > 0)
                a_over_3 = 0;
    
            let half_b = 0.5 * (c0 + c2_over_3 * (2.0 * c2_over_3 * c2_over_3 - c1));
    
            let q = half_b * half_b + a_over_3 * a_over_3 * a_over_3;
            if (q > 0)
                q = 0;
    
            // Compute the eigenvalues by solving for the roots of the polynomial.
            let rho = Math.sqrt(-a_over_3);
            let theta = Math.atan2(Math.sqrt(-q), half_b) * s_inv3;
            let cos_theta = Math.cos(theta);
            let sin_theta = Math.sin(theta);
    
            roots[0] = c2_over_3 + 2.0 * rho * cos_theta;
            roots[1] = c2_over_3 - rho * (cos_theta + s_sqrt3 * sin_theta);
            roots[2] = c2_over_3 - rho * (cos_theta - s_sqrt3 * sin_theta);
    
            // Sort in increasing order.
            if (roots[0] >= roots[1]) {
                [roots[0], roots[1]] = [roots[1], roots[0]];
            }
            if (roots[1] >= roots[2]) {
                [roots[1], roots[2]] = [roots[2], roots[1]];
                if (roots[0] >= roots[1]) {
                    [roots[0], roots[1]] = [roots[1], roots[0]];
                }
            }
    
            // If the smallest root is non-positive, adjust it (e.g., for positive semi-definite matrices)
            if (roots[0] <= 0) {
                computeRoots2(c2, c1, roots);
            }
        }
        return roots;
    }
    getLargest3x3Eigenvector(scaledMatrix) {
        // Assuming scaledMatrix is a 3x3 matrix, represented as a 2D array (array of arrays)
        
        // Compute the cross products
        let crossProduct = [
            this.crossProductOfRows(scaledMatrix[0], scaledMatrix[1]),
            this.crossProductOfRows(scaledMatrix[0], scaledMatrix[2]),
            this.crossProductOfRows(scaledMatrix[1], scaledMatrix[2])
        ];
        
        // Compute the norms (lengths) of each cross product vector
        let len = crossProduct.map(row => Math.sqrt(row.reduce((sum, val) => sum + val * val, 0)));
        
        // Find the index of the maximum length (norm)
        let maxLength = Math.max(...len);
        let index = len.indexOf(maxLength);
        
        // Return the largest eigenvector and its length
        let largestEigenvector = crossProduct[index].map(val => val / maxLength);
        
        // return { eigenvector: largestEigenvector, length: maxLength };
        return [ largestEigenvector[0], largestEigenvector[1], largestEigenvector[2], maxLength ];
    }
    
    // Helper function to compute the cross product of two 3D vectors
    crossProductOfRows(v1, v2) {
        return [
            v1[1] * v2[2] - v1[2] * v2[1],  // x-component
            v1[2] * v2[0] - v1[0] * v2[2],  // y-component
            v1[0] * v2[1] - v1[1] * v2[0]   // z-component
        ];
    }

    eigen33(mat) {
        let eigenvector;
        let eigenvalue;
        // Ensure that mat is a 3x3 matrix (represented as an array of arrays)
        // if (mat.length !== 3 || mat[0].length !== 3) {
        //     throw new Error("Input matrix must be a 3x3 matrix.");
        // }
    
        // Scale the matrix so its entries are in [-1, 1]
        // let scale = Math.max(Math.abs(mat[0*3+0]), Math.abs(mat[0*3+1]), Math.abs(mat[0*3+2]), 
        //                      Math.abs(mat[1*3+0]), Math.abs(mat[1*3+1]), Math.abs(mat[1*3+2]), 
        //                      Math.abs(mat[2*3+0]), Math.abs(mat[2*3+1]), Math.abs(mat[2*3+2]));
        let scale = Math.max(Math.abs(mat[0][0]), Math.abs(mat[0][1]), Math.abs(mat[0][2]), 
        Math.abs(mat[1][0]), Math.abs(mat[1][1]), Math.abs(mat[1][2]), 
        Math.abs(mat[2][0]), Math.abs(mat[2][1]), Math.abs(mat[2][2]));
        if (scale <= Number.MIN_VALUE) {
            scale = 1.0;
        }
        let matTmp = [
            [mat[0][0], mat[0][1], mat[0][2]],
            [mat[1][0], mat[1][1], mat[1][2]],
            [mat[2][0], mat[2][1], mat[2][2]]
          ];
        // Scale the matrix
        let scaledMat = matTmp.map(row => row.map(value => value / scale));
    
        // Compute eigenvalues (you would need a helper function or library to do this in real applications)
        let eigenvalues = this.computeRoots(scaledMat);
    
        // The eigenvalue is the first eigenvalue scaled back by 'scale'
        eigenvalue = eigenvalues[0] * scale;
    
        // Check if the first two eigenvalues are different
        const epsilon = Number.EPSILON;
        if (Math.abs(eigenvalues[1] - eigenvalues[0]) > epsilon) {
            // If the first and second eigenvalues are different, calculate the eigenvector
            scaledMat = this.subtractDiagonal(scaledMat, eigenvalues[0]);
            eigenvector = this.getLargest3x3Eigenvector(scaledMat);
        }
        else if (Math.abs(eigenvalues[2] - eigenvalues[0]) > epsilon) {
            // If the first and second eigenvalues are the same, choose a unit vector orthogonal to the third eigenvector
            scaledMat = this.subtractDiagonal(scaledMat, eigenvalues[2]);
            eigenvector = this.getLargest3x3Eigenvector(scaledMat);
            eigenvector = this.unitOrthogonal(eigenvector);
        }
        else {
            // If all eigenvalues are equal, just pick an arbitrary unit vector
            eigenvector = [1.0, 0.0, 0.0];
        }
        return { eigenvector, eigenvalue };
        // return eigenvector;
    }
    
    // Helper function: Subtract diagonal elements (eigenvalue from the diagonal)
    subtractDiagonal(mat, eigenvalue) {
        let newMat = mat.map((row, i) => {
            let newRow = row.slice();
            newRow[i] -= eigenvalue;  // Subtract eigenvalue from diagonal
            return newRow;
        });
        return newMat;
    }
    
    // Helper function: Normalize the eigenvector to unit length
    unitOrthogonal(vec) {
        const norm = Math.sqrt(vec[0] * vec[0] + vec[1] * vec[1] + vec[2] * vec[2]);
        return vec.map(v => v / norm);
    }
    computeMeanAndCovarianceMatrix(cloud, indices, covarianceMatrix, centroid) {
        // Shifted data/with estimate of mean. This gives very good accuracy and good performance.
        let accu = new Array(9).fill(0); // Equivalent to Eigen::Matrix<Scalar, 1, 9, Eigen::RowMajor>::Zero ()
        let K = { x: 0.0, y: 0.0, z: 0.0 };
    
        // Use the first valid point to initialize K
        for (let i = 0; i < indices.length; i++) {
            const index = indices[i];
            const point = cloud[index];
            if (isFinite(point.x) && isFinite(point.y) && isFinite(point.z)) {
                K.x = point.x;
                K.y = point.y;
                K.z = point.z;
                break;
            }
        }
    
        let pointCount = 0;
    
        // Check if the cloud is dense
        const isDense = cloud.isDense || true; // Assuming a property for dense clouds, or defaulting to true
    
        // Iterate through the indices
        if (isDense) {
            pointCount = indices.length;
            for (let i = 0; i < indices.length; i++) {
                const index = indices[i];
                const point = cloud[index];
                const x = point.x - K.x;
                const y = point.y - K.y;
                const z = point.z - K.z;
    
                accu[0] += x * x;
                accu[1] += x * y;
                accu[2] += x * z;
                accu[3] += y * y;
                accu[4] += y * z;
                accu[5] += z * z;
                accu[6] += x;
                accu[7] += y;
                accu[8] += z;
            }
        } else {
            pointCount = 0;
            for (let i = 0; i < indices.length; i++) {
                const index = indices[i];
                const point = cloud[index];
    
                if (!isFinite(point.x) || !isFinite(point.y) || !isFinite(point.z)) continue;
    
                pointCount++;
                const x = point.x - K.x;
                const y = point.y - K.y;
                const z = point.z - K.z;
    
                accu[0] += x * x;
                accu[1] += x * y;
                accu[2] += x * z;
                accu[3] += y * y;
                accu[4] += y * z;
                accu[5] += z * z;
                accu[6] += x;
                accu[7] += y;
                accu[8] += z;
            }
        }
    
        if (pointCount !== 0) {
            // Normalize the accumulator
            for (let i = 0; i < accu.length; i++) {
                accu[i] /= pointCount;
            }
    
            centroid.x = centroid[0] = accu[6] + K.x;
            centroid.y = centroid[1] = accu[7] + K.y;
            centroid.z = centroid[2] = accu[8] + K.z;
            centroid.w = centroid[3] = 1;
    
            // Fill the covariance matrix
            covarianceMatrix.elements[0] = covarianceMatrix[0] = accu[0] - accu[6] * accu[6]; // (0,0) xx
            covarianceMatrix.elements[1] = covarianceMatrix[1] = accu[1] - accu[6] * accu[7]; // (0,1) xy
            covarianceMatrix.elements[2] = covarianceMatrix[2] = accu[2] - accu[6] * accu[8]; // (0,2) xz
            covarianceMatrix.elements[3] = covarianceMatrix[3] = covarianceMatrix[1];         // (1,0) yx
            covarianceMatrix.elements[4] = covarianceMatrix[4] = accu[3] - accu[7] * accu[7]; // (1,1) yy
            covarianceMatrix.elements[5] = covarianceMatrix[5] = accu[4] - accu[7] * accu[8]; // (1,2) yz
            covarianceMatrix.elements[6] = covarianceMatrix[6] = covarianceMatrix[2];         // (2,0) zx
            covarianceMatrix.elements[7] = covarianceMatrix[7] = covarianceMatrix[5];         // (2,1) zy
            covarianceMatrix.elements[8] = covarianceMatrix[8] = accu[5] - accu[8] * accu[8]; // (2,2) zz
        }
    
        return pointCount;
    }
    
    // Wrapper for pcl::PointIndices
    computeMeanAndCovarianceMatrixWithIndices(cloud, indicesObj, covarianceMatrix, centroid) {
        return this.computeMeanAndCovarianceMatrix(cloud, indicesObj.indices, covarianceMatrix, centroid);
    }
    optimizeModelCoefficients(inliers, modelCoefficients) {
        let optimizedCoefficients;
        // Needs a valid set of model coefficients
        if (!this.isModelValid(modelCoefficients)) {
            console.error("[SampleConsensusModelPlane::optimizeModelCoefficients] Given model is invalid!");
            optimizedCoefficients = modelCoefficients;
            return optimizedCoefficients;
        }
    
        // Need more than the minimum sample size to make a difference
        if (inliers.length <= this.sampleSize_) {
            console.error(`[SampleConsensusModelPlane::optimizeModelCoefficients] Not enough inliers found to optimize model coefficients (${inliers.length})! Returning the same coefficients.`);
            optimizedCoefficients = modelCoefficients;
            return optimizedCoefficients;
        }
    
        let planeParameters;
    
        // Use Least-Squares to fit the plane through all the given sample points and find out its coefficients
        let covarianceMatrix = new THREE.Matrix3();
        let xyzCentroid = new THREE.Vector4();
    
        if (this.computeMeanAndCovarianceMatrix(this.input_, inliers, covarianceMatrix, xyzCentroid) === 0) {
            console.error("[SampleConsensusModelPlane::optimizeModelCoefficients] computeMeanAndCovarianceMatrix failed (returned 0) because there are no valid inliers.");
            optimizedCoefficients = modelCoefficients;
            return optimizedCoefficients;
        }
    
        // Compute the model coefficients
        let covarianceMatrix3x3 = new Matrix3x3() ;
        // covarianceMatrix3x3.transpose();

        covarianceMatrix3x3 = covarianceMatrix3x3.convertTHREEToMatrix3x3(covarianceMatrix);
        let eigenValue;
        let eigenVector;
        let ret = this.eigen33(covarianceMatrix3x3);
        eigenValue = ret.eigenvalue;
        eigenVector = ret.eigenvector;

        // Hessian form (D = nc . p_plane (centroid here) + p)
        optimizedCoefficients = new Float32Array(4);
        optimizedCoefficients[0] = eigenVector[0];
        optimizedCoefficients[1] = eigenVector[1];
        optimizedCoefficients[2] = eigenVector[2];
        optimizedCoefficients[3] = 0.0;
    
        // Dot product with the centroid
        let optimizedCoefficientsVec3 = new THREE.Vector3(optimizedCoefficients[0], optimizedCoefficients[1], optimizedCoefficients[2]);
        optimizedCoefficients[3] = -1.0 * this.dotProduct(optimizedCoefficientsVec3, xyzCentroid);
    
        // Make sure it results in a valid model
        if (!this.isModelValid(optimizedCoefficients)) {
            optimizedCoefficients = modelCoefficients;
        }
        return optimizedCoefficients;
    }
    projectPoints(inliers, modelCoefficients) {
        if (!this.isModelValid(modelCoefficients)) {
            console.error("[SampleConsensusModelPlane::projectPoints] Given model is invalid!");
            return [];
        }

        const projectedPoints = [];
        const mc = this.normalizeVector(modelCoefficients.slice(0, 3));

        inliers.forEach(inlier => {
            const pt = this.input[inlier];
            const distanceToPlane = this.dotProduct(mc, pt);
            const projectedPoint = pt.map((val, idx) => val - mc[idx] * distanceToPlane);
            projectedPoints.push(projectedPoint);
        });

        return projectedPoints;
    }

    crossProduct(p1, p0, p2) {
        // return [
        //     (p1.y - p0.y) * (p2.z - p0.z) - (p1.z - p0.z) * (p2.y - p0.y),
        //     (p1.z - p0.z) * (p2.x - p0.x) - (p1.x - p0.x) * (p2.z - p0.z),
        //     (p1.x - p0.x) * (p2.y - p0.y) - (p1.y - p0.y) * (p2.x - p0.x)
        // ];
        return new THREE.Vector3(
          (p1.y - p0.y) * (p2.z - p0.z) - (p1.z - p0.z) * (p2.y - p0.y),
          (p1.z - p0.z) * (p2.x - p0.x) - (p1.x - p0.x) * (p2.z - p0.z),
          (p1.x - p0.x) * (p2.y - p0.y) - (p1.y - p0.y) * (p2.x - p0.x)
        );
    }

    dotProduct(v1, v2) {
        return v1.x * v2.x + v1.y * v2.y + v1.z * v2.z;
    }
    dotProductVec4(v1, v2) {
        return v1.x * v2.x + v1.y * v2.y + v1.z * v2.z+ v1.w * v2.w;
    }
    dotProductVector(v1, v2) {
        return v1[0] * v2.x + v1[1] * v2.y + v1[2] * v2.z;
    }
    vectorNorm(v) {
        // return Math.sqrt(v[0] * v[0] + v[1] * v[1] + v[2] * v[2]);
        return Math.sqrt(v.x * v.x + v.y * v.y + v.z * v.z);
      }

    isModelValid(modelCoefficients) {
        return modelCoefficients.length === this.modelSize_;
    }

    normalizeVector(v) {
        const norm = this.vectorNorm(v);
        return v.map(val => val / norm);
    }
}

// Usage Example:
// const inputPoints = [{x: 1, y: 2, z: 3}, {x: 4, y: 5, z: 6}, {x: 7, y: 8, z: 9}]; // example 3D points
// const sampleSize = 3;
// const model = new SampleConsensusModelPlane(inputPoints, sampleSize);
// const samples = [0, 1, 2];  // example sample indices
// const modelCoefficients = model.computeModelCoefficients(samples);

// if (modelCoefficients) {
//     const inliers = model.selectWithinDistance(modelCoefficients, 1.0);
//     const projectedPoints = model.projectPoints(inliers, modelCoefficients);
//     console.log(projectedPoints);
// }
